/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */

export default {
    'cargo.agregarcargo': 'Agregar Cargo ',
    'cargo.modificarcargo': 'Editar Cargo',
    'cargo.NombreCargo': 'Nombre Cargo',
    'cargo.DescripcionCargo': 'Descripción Cargo',
    'cargo.Estado': 'Estado',
    'sidebar.cargo': 'Cargo',
    'titulo.Cargo': 'Cargo',
};
